import type { LC, LiveElement, PropsWithChildren } from '@use-gpu/live';
import type { UseLight } from '../light/types';
import type { LightEnv } from '../pass/types';

import { LightData } from '../render/light/light-data';

import { use, provide, useContext, useNoContext, makeContext } from '@use-gpu/live';

export type LightContextProps = UseLight;

export const DEFAULT_LIGHT_CONTEXT = () => { console.warn('Light used in a pass without lights enabled.'); };

export const LightContext = makeContext<LightContextProps>(DEFAULT_LIGHT_CONTEXT, 'LightContext');

export const useLightContext = () => useContext(LightContext);
export const useNoLightContext = () => useNoContext(LightContext);

export type LightProviderProps = PropsWithChildren<{
  shadows?: boolean,
  then?: (
    lightEnv: LightEnv,
  ) => LiveElement,
}>;

export const LightProvider: LC<LightProviderProps> = (props: LightProviderProps) => {
  const {
    shadows,
    children,
    then,
  } = props;

  // Gather light data into a uniform buffer
  return use(LightData, {
    shadows,
    render: (useLight: UseLight) => provide(LightContext, useLight, children),
    then,
  });
};
